/** Konsultasi-platform thread + message live queries. */

import { COL } from '../../collections';
import { where, orderBy } from '../../collections';
import { useLiveQuery } from '../hooks';
import type { ConsultDoc, ConsultMessageDoc } from '../../types';

/** Consult threads of a skripsi (mahasiswa ↔ dosen pembimbing/penguji). */
export function useConsultsForSkripsi(skripsiId: string | null) {
  return useLiveQuery<ConsultDoc>(
    skripsiId ? COL.consults : null,
    skripsiId ? [where('skripsiId', '==', skripsiId), orderBy('createdAt', 'asc')] : [],
    Boolean(skripsiId),
  );
}

/** Consult threads addressed to a dosen (inbox). */
export function useConsultsForDosen(dosenId: string | null) {
  return useLiveQuery<ConsultDoc>(
    dosenId ? COL.consults : null,
    dosenId ? [where('dosenId', '==', dosenId), orderBy('createdAt', 'desc')] : [],
    Boolean(dosenId),
  );
}

/** Consult threads initiated by a mahasiswa. */
export function useConsultsForMahasiswa(mahasiswaId: string | null) {
  return useLiveQuery<ConsultDoc>(
    mahasiswaId ? COL.consults : null,
    mahasiswaId ? [where('mahasiswaId', '==', mahasiswaId), orderBy('createdAt', 'desc')] : [],
    Boolean(mahasiswaId),
  );
}

/** All consult threads (kaprodi recap / investigation). */
export function useAllConsults() {
  return useLiveQuery<ConsultDoc>(COL.consults, [orderBy('createdAt', 'asc')]);
}

/** Chat messages of a konsultasi thread, oldest first. */
export function useConsultMessages(consultId: string | null) {
  return useLiveQuery<ConsultMessageDoc>(
    consultId ? COL.consultMessages : null,
    consultId ? [where('consultId', '==', consultId), orderBy('createdAt', 'asc')] : [],
    Boolean(consultId),
  );
}
